module.exports = __webpack_public_path__ + "static/cycle-73090901b530f57d46e8913e6aae844d.png";